import { Col, Container, Row } from 'react-bootstrap';

import { getCurrentMonthRange } from '../helpers/dateRange';
import {
  useDailyFinancials,
  useDashboardKpis,
  usePendingOrders,
  useRevenueByType,
  useRevenueTrend
} from '../hooks/useDashboard';
import AnalyticsAverageTime from '../widgets/AnalyticsAverageTime';
import AnalyticsConversions from '../widgets/AnalyticsConversions';
import AnalyticsExit from '../widgets/AnalyticsExit';
import AnalyticsProjects from '../widgets/AnalyticsProjects';
import AnalyticsSales from '../widgets/AnalyticsSales';
import AnalyticsTotalHours from '../widgets/AnalyticsTotalHours';
import AnalyticsTrafficChannels from '../widgets/AnalyticsTrafficChannels';
import AnalyticsValue from '../widgets/AnalyticsValue';
import AnalyticsHeader from '../widgets/Header';

const Dashboard = () => {
  const dateRange = getCurrentMonthRange();

  const { data: kpisData, isLoading: kpisLoading } = useDashboardKpis(dateRange);
  const { data: dailyFinancials, isLoading: financialsLoading } = useDailyFinancials(dateRange);
  const { data: revenueByType, isLoading: revenueByTypeLoading } = useRevenueByType(dateRange);
  const { data: pendingOrders, isLoading: pendingOrdersLoading } = usePendingOrders({ limit: 5 });
  const { data: revenueTrend, isLoading: revenueTrendLoading } = useRevenueTrend(dateRange);

  return (
    <div className="main-content">
      <AnalyticsHeader title="Dashboard" />
      <Container fluid>
        <Row>
          <Col xs={12} md={6} xl>
            <AnalyticsValue data={kpisData?.totalRevenue} isLoading={kpisLoading} />
          </Col>
          <Col xs={12} md={6} xl>
            <AnalyticsTotalHours data={kpisData?.totalExpenses} isLoading={kpisLoading} />
          </Col>
          <Col xs={12} md={6} xl>
            <AnalyticsExit data={kpisData?.totalCreditsOwed} isLoading={kpisLoading} />
          </Col>
          <Col xs={12} md={6} xl>
            <AnalyticsAverageTime data={kpisData?.pendingOrders} isLoading={kpisLoading} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={8}>
            <AnalyticsConversions data={dailyFinancials} isLoading={financialsLoading} />
          </Col>
          <Col xs={12} xl={4}>
            <AnalyticsTrafficChannels data={revenueByType} isLoading={revenueByTypeLoading} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} xl={4}>
            <AnalyticsProjects data={pendingOrders} isLoading={pendingOrdersLoading} />
          </Col>
          <Col xs={12} xl={8}>
            <AnalyticsSales data={revenueTrend} isLoading={revenueTrendLoading} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;
